// @mui
import { RadioGroup } from '@mui/material';
//
import { useSettingsContext } from '../SettingsContext';
import { StyledCard, StyledWrap, MaskControl, LayoutIcon } from '../styles';

// ----------------------------------------------------------------------

const OPTIONS = ['vertical', 'horizontal', 'mini'] as const;

export default function LayoutOptions() {
  // RITA-1585: Die Auswahl zeigt die eigene Einstellung, nicht die vorübergehende Menü-Darstellung (Handbuch offen).
  const { gespeichertesLayout, onChangeLayout } = useSettingsContext();

  return (
    <RadioGroup name="themeLayout" value={gespeichertesLayout} onChange={onChangeLayout}>
      <StyledWrap sx={{ gridTemplateColumns: 'repeat(3, 1fr)' }}>
        {OPTIONS.map((layout) => (
          <StyledCard key={layout} selected={gespeichertesLayout === layout} sx={{ p: 0.75, height: 56 }}>
            <LayoutIcon layout={layout} />

            <MaskControl value={layout} />
          </StyledCard>
        ))}
      </StyledWrap>
    </RadioGroup>
  );
}
